import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid';
import Breadcrumb from '../Breadcrumbs/Breadcrumb';
import Loader from '../Loader/Loader';
import RouteConstants from '../../constant/Routeconstant';
import siteQueries from '../../queries/siteQueries';
import userQueries from '../../queries/userQueries';
import { BASE_URL } from '../../apis/api';

const Featuredspeaker = () => {
  const [photogallery, setPhotogallery] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const speakerlisting = siteQueries.useFeaturedspeakerListingMutation(
    async (response) => {
      setPhotogallery(response?.data || []);
      setIsLoading(false);
    },
    {
      onError: (error) => {
        setError('Failed to fetch speaker list. Please try again later.');
        setIsLoading(false);
      }
    }
  );

  useEffect(() => {
    setIsLoading(true);
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    speakerlisting.mutate('');
  };

  const handleAddfeaturedspeaker = () => {
    navigate(RouteConstants.ADDFEATUREDSPEAKER);
  };

 
  const removefeaturedspeaker = userQueries.useFeaturedspeakerMutation(
    
    (response) => {
      console.log(response)
      
        
        fetchUsers();
      
      
  }
  );
  const handleDelete = async (event, id) => {
    
    event.preventDefault();
    if (window.confirm('Are you sure you want to remove this speaker?')) {
      await removefeaturedspeaker.mutateAsync(id);
    }
  }
 

  return (
    <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
      <div className="flex justify-between items-center mb-4">
        <Breadcrumb pageName="Featured Speaker" />
        <div className="flex flex-col sm:flex-row gap-2">
          <button 
            className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-2 shadow-lg transition duration-300 ease-in-out transform hover:scale-105"
            title="Add Featured Speaker"
            aria-label="Add Featured Speaker"
            onClick={handleAddfeaturedspeaker}
          
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </button>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <div className="text-red-500 text-center p-4">{error}</div>
      ) : (
        <div className="flex flex-col">
        <div className="grid grid-cols-[0.5fr_.8fr_1.5fr_1fr_1fr_1fr] sm:grid-cols-[0.5fr_.8fr_1.5fr_1fr_1fr_1fr] border-b border-stroke bg-gray-800 dark:bg-meta-4">
          <div className="p-2 text-xs font-medium uppercase xsm:text-sm">Sl no.</div>
          <div className="p-2 text-xs font-medium uppercase xsm:text-sm">Name</div>
          <div className="p-2 text-xs font-medium uppercase xsm:text-sm">Image</div>
          <div className="p-2 text-xs font-medium uppercase xsm:text-sm">Actions</div>
        </div>
      
        {photogallery.map((gallerydata, index) => (
          <div
            key={index}
            className="grid grid-cols-[0.5fr_.8fr_1.5fr_1fr_1fr_1fr] sm:grid-cols-[0.5fr_.8fr_1.5fr_1fr_1fr_1fr] border-b border-stroke bg-gray-200 dark:bg-meta-4"
          >
            <div className="p-2 text-xs xsm:text-sm">{index + 1}</div>
            <div className="p-2 text-xs xsm:text-sm">
              {gallerydata.speaker.heading}
            </div>
            
            <div className="p-2 text-xs xsm:text-sm">
              {gallerydata.speaker.photo ? (
                <img
                  src={`${BASE_URL}/${gallerydata.speaker.photo}`}
                  alt="Speaker"
                  className="h-12 w-12 object-cover"
                />
              ) : (
                <div className="h-12 w-12 bg-gray-200" />
              )}
            </div>

            

         
          

            
            <div className="p-2 text-xs xsm:text-sm flex items-center gap-3">
              
            <TrashIcon
            onClick={(e) => handleDelete(e, gallerydata.speaker.id)}
            className="h-6 w-6 text-black-600 cursor-pointer hover:text-red-600"
            aria-hidden="true"
          />
            </div>
          </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default Featuredspeaker;